module.exports = __webpack_public_path__ + "img/chat.89c86ea4.svg";